<template>
  <div>
    <el-row>

      <el-col :span="6" style="display: flex; justify-content: center">
        <el-radio size="mini" @change="showPinji" v-model="radio" label="5">全部评级&nbsp;</el-radio>
        <el-radio size="mini" @change="showPinji" v-model="radio" label="0">未评级&nbsp;&nbsp;</el-radio>
        <el-radio size="mini" @change="showPinji" v-model="radio" label="1">D量&nbsp;&nbsp;</el-radio>
        <el-radio size="mini" @change="showPinji" v-model="radio" label="2">C量&nbsp;&nbsp;</el-radio>
        <el-radio size="mini" @change="showPinji" v-model="radio" label="3">B量&nbsp;&nbsp;</el-radio>
        <el-radio size="mini" @change="showPinji" v-model="radio" label="4">A量&nbsp;&nbsp;</el-radio>

      </el-col>
      <el-col :span="2" style="display: flex; justify-content: center">
        <el-tag size="mini" type="success">合计: {{ showListDatas.length }} 名</el-tag>
      </el-col>
      <el-col :span="10" style="display: flex; justify-content: center">
        <el-button style="padding: 12px; display: inline-block; margin: 0 11px" @click="toNavi(-1)"
          type="primary">《《</el-button>
        <el-date-picker v-model="dateVal" type="date" placeholder="选择日期">
        </el-date-picker>
        <el-button style="padding: 12px; display: inline-block; margin: 0 11px" @click="toNavi(1)"
          type="primary">》》</el-button>
      </el-col>

      <el-col :span="4" style="display: flex; justify-content: center">
        <el-switch @change="chgSwitch" style="display: block" v-model="isGenJ" active-color="#13ce66" inactive-color="#ff4949"
          active-text="已跟进" inactive-text="全部">
        </el-switch>

      </el-col>
    </el-row>
    <div>
      <el-divider></el-divider>
      <el-tabs v-if="activeNameList && activeNameList.length > 0" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(un, idx) in activeNameList" :label="un" :name="un">
          <el-row>
            <el-col v-if="showListDatas && showListDatas.length > 0" v-for="(itm, idx2) in showListDatas" :span="6">
              <el-card shadow="hover"
                :title="itm.rank ? (itm.rank == '1' ? 'D量' : (itm.rank == '2' ? 'C量' : (itm.rank == '3' ? 'B量' : (itm.rank == '4' ? 'A量' : '未评级')))) : '未评级'"
                :class="itm.needdy == 1 ? 'box-card' : (itm.rank ? (itm.rank == '1' ? 'box-cardD' : (itm.rank == '2' ? 'box-cardC' : (itm.rank == '3' ? 'box-cardB' : (itm.rank == '4' ? 'box-cardA' : 'box-card')))) : 'box-card')">
                <div class="clearfix">
                  <span> <b>
                      <el-button type="danger" @click="showConus(idx2)" plain>{{ idx2 + 1 }}. {{ itm.name
                        }}</el-button>
                    </b>&nbsp;<el-tag size="mini"
                      :type="itm.type == 1 ? 'warning' : (itm.type == 2 ? 'success' : 'primary')">{{ itm.type == 1 ?
        '电邀' : (itm.type == 2 ? '咨询' : (itm.type == 4 ? '辅助' : '其他')) }}-{{ itm.uid }}</el-tag> </span>
                  <span style=" float: right;">
                    <el-tag size="mini" type="info"> {{ itm.gjdate }}跟进 | {{ itm.crtm }}导入 </el-tag> </span>
                </div>
                <hr>
                <div class="text item">
                  {{ itm.remark }}
                </div>

              </el-card>
            </el-col>
          </el-row>

        </el-tab-pane>
      </el-tabs>
      <p v-else>{{ dateVal.format("yyyy-MM-dd") }}没有数据</p>

    </div>
    <attckone ref="attckone"></attckone>
  </div>
</template>

<script>

import api from "@/api/consu/consultationxl/consultationrecordxl.js";
import attckone from "./kanbanonexl.vue";
export default {
  components: {
    attckone
  },
  data() {
    return {
      activeName: "",
      activeNameList: [],
      listDatas: [],
      showListDatas: [],
      dateVal: new Date(),
      usertype: 0,
      radio: '5',
      zxs: [],
      isGenJ: true
    };
  },
  methods: {

    showConus(idx) {

      this.$refs.attckone.open(
        idx,
        this.showListDatas,
        this.me,
        this.zxs,
        "看板-查看跟进"
      );

    },
    showPinji(val) {
      //console.log(val)
      if (val == '5') {
        this.showListDatas = this.listDatas
      } else if (val != '0') {
        this.showListDatas = this.listDatas.filter(v => v.rank == val)
      } else {
        this.showListDatas = this.listDatas.filter(v => (!v.rank))
      }
    },
    toNavi(val) {

      let time = 0;
      if (val > 0) {
        time = this.dateVal.getTime() + 1000 * 60 * 60 * 24;
      } else {
        time = this.dateVal.getTime() - 1000 * 60 * 60 * 24;
      }

      this.$set(this, "dateVal", new Date(time));
      this.loaddata();

    }, handleClick(tab, event) {
      this.activeName = tab.name
      if (this.usertype == 2) {
        api.listByUname({ day: this.dateVal.format("yyyy-MM-dd"), unm: this.activeName ,all:(!this.isGenJ)}, res => {
          this.listDatas = res.data
          this.showListDatas = this.listDatas
        })

      } else {
        api.listByUname({ day: this.dateVal.format("yyyy-MM-dd") }, res => {
          this.listDatas = res.data
          this.showListDatas = this.listDatas
        })
      }

    },chgSwitch() {
      if (this.usertype == 2) {
            api.listByUname({ day: this.dateVal.format("yyyy-MM-dd"), unm: this.activeName ,all:(!this.isGenJ)}, res => {
              this.listDatas = res.data
              this.showListDatas = this.listDatas
            })
          
      } else {
        api.listByUname({ day: this.dateVal.format("yyyy-MM-dd"),all:(!this.isGenJ) }, res => {
          this.activeNameList = [this.me.name]
          this.activeName = this.me.name
          this.listDatas = res.data
          this.showListDatas = this.listDatas
        })
      }

    },

    loaddata() {
      if (this.usertype == 2) {
        api.listSnameAtDay({ day: this.dateVal.format("yyyy-MM-dd") }, res => {
          this.activeNameList = res.data

          if (this.activeNameList && this.activeNameList.length > 0) {
     
              this.activeName = this.activeNameList[0]

            api.listByUname({ day: this.dateVal.format("yyyy-MM-dd"), unm: this.activeName ,all:(!this.isGenJ)}, res => {

              this.listDatas = res.data
              this.showListDatas = this.listDatas
            })
          }
        })
      } else {
        api.listByUname({ day: this.dateVal.format("yyyy-MM-dd"),all:(!this.isGenJ) }, res => {
          this.activeNameList = [this.me.name]
          this.activeName = this.me.name
          this.listDatas = res.data
          this.showListDatas = this.listDatas
        })
      }

    },


  }, mounted() {

    this.dateVal = new Date();

    let roleCode = this.$caches.roleCode.get()[0];
    let role = roleCode.substring(0, 2)
    // console.log("this.role = ", role)
    this.me = this.$caches.user.get();
    this.zxs = this.$caches.users.get().zxs

    if (roleCode == "qdm") {
      this.usertype = 2;
    } else if (role == "dy") {
      this.usertype = 0;
    } else if (role == "zx" || role == "qd") {
      this.usertype = 1;
    } else {
      this.usertype = 2;
    }

    this.loaddata();
  },

};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 12px;
}


.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-cardA {
  width: 365px;
  height: 140px;
  margin-top: 5px;
  background-color: rgb(152, 214, 122)
}

.box-cardB {
  width: 365px;
  height: 140px;
  margin-top: 5px;
  background-color: rgb(124, 189, 254)
}

.box-cardC {
  width: 365px;
  height: 140px;
  margin-top: 5px;
  background-color: rgb(237, 190, 120)
}

.box-cardD {
  width: 365px;
  height: 140px;
  margin-top: 5px;
  background-color: rgb(255, 234, 234)
}

.box-card {
  width: 365px;
  height: 140px;
  margin-top: 5px;
}

::v-deep .el-card__body,
.el-main {
  padding: 10px !important;
}
</style>